import { gql } from '@apollo/client'

import { useQuery } from 'hooks'

const CONFIG_BY_NAME_QUERY = gql`
  query Config($name: String!) {
    configByName(name: $name) {
      id
      name
      value
      description
    }
  }
`

export const useConfigByNameDetailQuery = (name, opts) => useQuery(CONFIG_BY_NAME_QUERY, opts, { name })
